import $ from 'jquery';

import * as Website from '../Config/Website.js';


const Tab = {
  init() {
    this.tabSwitch();
  },
  tabSwitch() {
    $(document).on('click', '.js-tab', function(e) {
      // イベントの伝播を停止
      e.stopPropagation();
      
      // 最も近い親の.js-tab-groupを取得
      const $tabGroup = $(this).closest('.js-tab-group');
      
      // ネストされたタブグループを除外するために、
      // 現在のタブグループ内の直接の子孫のみを対象にする
      const $tabs = $tabGroup.find('.js-tab').filter(function() {
        return $(this).closest('.js-tab-group')[0] === $tabGroup[0];
      });
      
      const $contents = $tabGroup.find('.js-content').filter(function() {
        return $(this).closest('.js-tab-group')[0] === $tabGroup[0];
      });
      
      // タブの切り替え
      $tabs.removeClass(Website.classList.act);
      $(this).addClass(Website.classList.act);
      
      // クリックされたタブのインデックスを取得
      const index = $tabs.index(this);
      
      // コンテンツの切り替え
      $contents.removeClass(Website.classList.act).eq(index).addClass(Website.classList.act);
    });
  }
}
// 初期化
Tab.init();

export default Tab;